import { Avatar as AvatarMUI } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

type MessageComponentProps = {
  isSender: boolean;
  isScheduled?: boolean;
  width?: string;
};

type BodyProps = {
  isSender: boolean;
};

export const Container = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  border-radius: 10px;
  padding-bottom: 10px;
  overflow-wrap: anywhere;
`;

export const MessageComponent = lib.styled.div<MessageComponentProps>`
  display: flex;
  flex-direction: column;
  width: ${(props: MessageComponentProps) => props.width ?? '270px'};
  padding: 10px;
  border-radius: 8px;
  gap: 10px;
  color: ${colors.darkGray13};
  background-color: ${(props: MessageComponentProps) =>
    props.isScheduled ? `${colors.yellow05}!important` : 'unset'};
  background-color: ${(props: BodyProps) =>
    props.isSender ? colors.lightBlue14 : colors.lightGray19};
`;

export const Body = lib.styled.div`
    display: flex;
    flex-direction: column;
    font-size: 16px;
    white-space: pre-wrap;
    line-height: 1.6;

    .highlighter {
      background-color: unset;
      font-weight: bold;
      color: ${colors.black} !important;
    }

    a {
      color: ${colors.lightBlue05};
      font-size: 16px;
      text-decoration: underline;
      cursor: pointer;
    }

    a:hover {
      color: ${colors.lightBlue02};
    }
`;

export const Footer = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props: BodyProps) =>
    props.isSender ? 'flex-end' : 'flex-start'};
  gap: 5px;
  font-size: 10px;
  color: ${colors.gray};

  .channel-icon {
    display: flex;
    align-items: center;

    div {
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 12px;
        height: 12px;
      }
    }
  }

  .icon {
    margin-top: -2px;
    width: 13px;
    height: 13px;
  }

  .delivered {
    color: ${colors.gray};
  }

  .read {
    color: ${colors.lightBlue05};
  }

  .failed {
    color: ${colors.red};
  }
  
`;

export const Avatar = lib.styled(AvatarMUI)`
  width: 25px !important;
  height: 25px !important;
  margin-right: 8px;
  margin-right: ${(props: any) => (props.marginRight ? '8px' : '0px')};
  margin-left: ${(props: any) => (props.marginLeft ? '8px' : '0px')};
  border: 1.8px solid ${colors.white};
  background-color: ${colors.lightGray10};
  opacity: 0.5;
  span {
    font-size: 10px;
    color: ${colors.black} !important;
  }
`;

export const Scheduled = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 5px;

  span {
    flex: 1;
  }

  .MuiButtonBase-root {
    color: ${colors.red};
    padding: 0px 2px;
    min-width: unset;
    font-size: 12px;
    font-weight: 600;
    text-transform: none !important;
  }

  .MuiButton-root:hover {
    background-color: transparent;
    text-decoration: underline;
  }
`;
